<mat-nav-list class="sd_bar" [class.sd_bar--student-v2]="profile?.role === UserRole.STUDENT">
  <button type="button" class="closeSidebar" (click)="toggleSidenav()">
    <mat-icon>close</mat-icon>
  </button>
  <!-- <div class="logo-brand">
    <figure class="logo" [routerLink]="logoHomePath">
      <img [src]="webLogo ?? assetsConst.logo1" alt="logo" />
    </figure>
  </div> -->

  @if (profile?.role === UserRole.STUDENT) {
    <div class="sidebar1 sidebar1--v2">
      <div class="sidebar-v2-stack">
        @for (item of studentNavV2Top; track item.path) {
          @if (!isSidebarItemHidden(item)) {
            <mat-list-item
              [routerLink]="navPath(item)"
              [ngClass]="{ active: isRouteActive(item) }"
              (click)="toggleSidenav()"
              class="sidebar-v2-item">
              @if (item.matIcon) {
                <span class="sd_cn sd_cn--mat" aria-hidden="true">
                  <mat-icon>{{ item.matIcon }}</mat-icon>
                </span>
              } @else {
                <figure class="sd_cn">
                  <img [src]="item.img" alt="" />
                </figure>
              }
              <div class="sidenav-item">
                <h5 class="lead">{{ item.text | translate }}</h5>
              </div>
            </mat-list-item>
          }
        }

        <div class="sidebar-v2-group">
          <button type="button" class="sidebar-v2-group__head" (click)="toggleLearnGroup()">
            <span>{{ 'NavGroupLearn' | translate }}</span>
            <mat-icon class="sidebar-v2-group__chev" [class.sidebar-v2-group__chev--open]="learnGroupOpen">expand_more</mat-icon>
          </button>
          @if (learnGroupOpen) {
            <div class="sidebar-v2-group__items">
              @for (item of studentNavV2Learn; track item.path) {
                @if (!isSidebarItemHidden(item)) {
                  <mat-list-item
                    [routerLink]="navPath(item)"
                    [ngClass]="{ active: isRouteActive(item) }"
                    (click)="toggleSidenav()"
                    class="sidebar-v2-item">
                    @if (item.matIcon) {
                      <span class="sd_cn sd_cn--mat" aria-hidden="true">
                        <mat-icon>{{ item.matIcon }}</mat-icon>
                      </span>
                    } @else {
                      <figure class="sd_cn">
                        <img [src]="item.img" alt="" />
                      </figure>
                    }
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.text | translate }}</h5>
                    </div>
                  </mat-list-item>
                }
              }
            </div>
          }
        </div>

        <div class="sidebar-v2-group">
          <button type="button" class="sidebar-v2-group__head" (click)="toggleManageGroup()">
            <span>{{ 'NavGroupManage' | translate }}</span>
            <mat-icon class="sidebar-v2-group__chev" [class.sidebar-v2-group__chev--open]="manageGroupOpen">expand_more</mat-icon>
          </button>
          @if (manageGroupOpen) {
            <div class="sidebar-v2-group__items">
              @for (item of studentNavV2Manage; track item.text) {
                @if (!isSidebarItemHidden(item)) {
                  @if (!item.isSubMenu) {
                    <mat-list-item
                      [routerLink]="navPath(item)"
                      [ngClass]="{ active: isRouteActive(item) }"
                      (click)="toggleSidenav()"
                      class="sidebar-v2-item">
                      @if (item.matIcon) {
                        <span class="sd_cn sd_cn--mat" aria-hidden="true">
                          <mat-icon>{{ item.matIcon }}</mat-icon>
                        </span>
                      } @else {
                        <figure class="sd_cn">
                          <img [src]="item.img" alt="" />
                        </figure>
                      }
                      <div class="sidenav-item">
                        <h5 class="lead">{{ item.text | translate }}</h5>
                      </div>
                    </mat-list-item>
                  } @else {
                    <mat-accordion class="sidebar-v2-item--accordion">
                      <mat-expansion-panel class="drop_lst_nv">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <mat-list-item class="sidebar-v2-item">
                              @if (item.matIcon) {
                                <span class="sd_cn sd_cn--mat" aria-hidden="true">
                                  <mat-icon>{{ item.matIcon }}</mat-icon>
                                </span>
                              } @else {
                                <figure class="sd_cn">
                                  <img [src]="item.img" alt="" />
                                </figure>
                              }
                              <div class="sidenav-item">
                                <h5 class="lead">{{ item.text | translate }}</h5>
                              </div>
                            </mat-list-item>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (sub of item.subMenuItems; track sub.path) {
                          <mat-list-item
                            [routerLink]="navPath(sub)"
                            [ngClass]="{ active: isRouteActive(sub) }"
                            (click)="toggleSidenav()"
                            (keydown)="toggleSidenav()"
                            tabindex="0"
                            class="sidebar-v2-item">
                            <figure class="sd_cn">
                              <img [src]="sub.img" alt="" />
                            </figure>
                            <div class="sidenav-item">
                              <h5 class="lead">{{ sub.text | translate }}</h5>
                            </div>
                          </mat-list-item>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  }
                }
              }
            </div>
          }
        </div>

      </div>
    </div>

    <div class="sidebar-v2-divider" aria-hidden="true"></div>

    <div class="sidebar2 sidebar2--v2">
      @for (item of sideBar2; track item.path) {
        <ng-container *ngIf="!item.isSubMenu && item.sideBarId !== SideBar2Const.Notification && !isSidebarItemHidden(item)">
          <mat-list-item
            [routerLink]="navPath(item)"
            [ngClass]="{ active: isRouteActive(item) }"
            (click)="toggleSidenav()"
            class="sidebar-v2-item">
            @if (item.matIcon) {
              <span class="sd_cn sd_cn--mat" aria-hidden="true">
                <mat-icon>{{ item.matIcon }}</mat-icon>
              </span>
            } @else {
              <figure class="sd_cn" [class.sd_cn--avatar]="item.isBotAvatar">
                <img [src]="item.img" alt="" />
              </figure>
            }
            <div class="sidenav-item">
              <h5 class="lead">
                {{ item.text | translate }}
                @if (item.sideBarId === SideBar2Const.Communication && chatNotificationCount && chatNotificationCount > 0) {
                  <span class="badge">{{ chatNotificationCount }}</span>
                }
                @if (item.sideBarId === SideBar2Const.Notification && notificationCount && notificationCount > 0) {
                  <span class="badge">{{ notificationCount }}</span>
                }
                @if (item.sideBarId === SideBar2Const.HelpSupport && supportNotificationCount && supportNotificationCount > 0) {
                  <span class="badge">{{ supportNotificationCount }}</span>
                }
              </h5>
            </div>
          </mat-list-item>
        </ng-container>
      }
    </div>

    <div class="sidebar-ai-balance">
      <mindbase-ai-balance-card />
    </div>
  } @else if (profile?.role === UserRole.PARENT) {
    <div class="sidebar1">
      <div *ngFor="let item of parentSideBar">
        @if (!isSidebarItemHidden(item)) {
          <ng-container *ngIf="!item.isSubMenu">
            <mat-list-item
              [routerLink]="navPath(item)"
              [ngClass]="{ active: isRouteActive(item) }"
              (click)="toggleSidenav()"
              (keydown)="toggleSidenav()"
              tabindex="0">
              <figure class="sd_cn">
                <img src="{{ item.img }}" alt="" />
              </figure>
              <div class="sidenav-item">
                <h5 class="lead">{{ item.text | translate }}</h5>
              </div>
            </mat-list-item>
          </ng-container>
          <mat-accordion *ngIf="item.isSubMenu">
            <mat-expansion-panel class="drop_lst_nv">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-list-item
                    (click)="toggleSidenav()">
                    <figure class="sd_cn" mat-raised-button>
                      <img src="{{ item.img }}" alt="" />
                    </figure>
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.text | translate }}</h5>
                    </div>
                  </mat-list-item>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list-item
                *ngFor="let sub of item.subMenuItems"
                [routerLink]="navPath(sub)"
                routerLinkActive="active"
                (click)="toggleSidenav()"
                (keydown)="toggleSidenav()"
                tabindex="0">
                <figure class="sd_cn">
                  <img [src]="sub.img" alt="images" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>

    <div class="sidebar2">
      <div *ngFor="let item of parentSideBar2">
        <ng-container *ngIf="!item.isSubMenu && !isSidebarItemHidden(item)">
          <mat-list-item
            [routerLink]="navPath(item)"
            [ngClass]="{ active: isRouteActive(item) }"
            (click)="toggleSidenav()"
            (keydown)="toggleSidenav()"
            tabindex="0">
            @if (item.matIcon) {
              <span class="sd_cn sd_cn--mat" aria-hidden="true">
                <mat-icon>{{ item.matIcon }}</mat-icon>
              </span>
            } @else {
              <figure class="sd_cn">
                <img src="{{ item.img }}" alt="item image" />
              </figure>
            }
            <div class="sidenav-item">
              <h5 class="lead">
                {{ item.text | translate }}
                @if (item.sideBarId === SideBar2Const.Communication && chatNotificationCount && chatNotificationCount > 0) {
                  <span class="badge">{{ chatNotificationCount }}</span>
                }
                @if (item.sideBarId === SideBar2Const.HelpSupport && supportNotificationCount && supportNotificationCount > 0) {
                  <span class="badge">{{ supportNotificationCount }}</span>
                }
              </h5>
            </div>
          </mat-list-item>
        </ng-container>
        <mat-accordion *ngIf="item.isSubMenu">
          <mat-expansion-panel class="drop_lst_nv">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-list-item
                  (click)="toggleSidenav()">
                  <figure class="sd_cn" mat-raised-button>
                    <img src="{{ item.img }}" alt="" />
                  </figure>
                  <div class="sidenav-item">
                    <h5 class="lead">{{ item.text | translate }}</h5>
                  </div>
                </mat-list-item>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list-item
              *ngFor="let sub of item.subMenuItems"
              [routerLink]="navPath(sub)"
              routerLinkActive="active"
              (click)="toggleSidenav()"
              (keydown)="toggleSidenav()"
              tabindex="0">
              <figure class="sd_cn">
                <img [src]="sub.img" alt="images" />
              </figure>
              <div class="sidenav-item">
                <h5 class="lead">{{ sub.text | translate }}</h5>
              </div>
            </mat-list-item>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  } @else {
    <div class="sidebar1">
      <div *ngFor="let item of sideBar">
        @if (!item.studentOnly && !isSidebarItemHidden(item)) {
          <ng-container *ngIf="!item.isSubMenu">
            <mat-list-item
              [routerLink]="navPath(item)"
              [ngClass]="{ active: isRouteActive(item) }"
              (click)="toggleSidenav()"
              (keydown)="toggleSidenav()"
              tabindex="0">
              <figure class="sd_cn">
                <img src="{{ item.img }}" alt="" />
              </figure>
              <div class="sidenav-item">
                <h5 class="lead">{{ item.text | translate }}</h5>
              </div>
            </mat-list-item>
          </ng-container>
          <mat-accordion *ngIf="item.isSubMenu">
            <mat-expansion-panel class="drop_lst_nv">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-list-item
                    (click)="toggleSidenav()">
                    <figure class="sd_cn" mat-raised-button>
                      <img src="{{ item.img }}" alt="" />
                    </figure>
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.text | translate }}</h5>
                    </div>
                  </mat-list-item>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list-item
                *ngFor="let sub of item.subMenuItems"
                [routerLink]="navPath(sub)"
                routerLinkActive="active"
                (click)="toggleSidenav()"
                (keydown)="toggleSidenav()"
                tabindex="0">
                <figure class="sd_cn">
                  <img [src]="sub.img" alt="images" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.text | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>

      <!-- Knowledge Bank — tutor and counsellor -->
      <!-- @if (profile?.role === UserRole.TUTOR || profile?.role === UserRole.COUNSELOR) {
        <mat-list-item
          routerLink="/tutor/ai-tutor"
          [ngClass]="{ active: router.url.includes('/tutor/ai-tutor') }"
          (click)="toggleSidenav()">
          <figure class="sd_cn">
            <img [src]="assetsConst.knowledgeBankIcon" alt="" />
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ 'KnowledgeBank' | translate }}</h5>
          </div>
        </mat-list-item>
      } -->
    </div>

    <div class="sidebar2">
      <div *ngFor="let item of sideBar2">
        <!-- Parent notifications are surfaced in the top bar, not the sidebar -->
        <ng-container *ngIf="!item.isSubMenu && item.sideBarId !== SideBar2Const.Notification && !item.studentOnly && !isSidebarItemHidden(item)">
          <mat-list-item
            [routerLink]="navPath(item)"
            [ngClass]="{ active: isRouteActive(item) }"
            (click)="toggleSidenav()"
            (keydown)="toggleSidenav()"
            tabindex="0">
            @if (item.matIcon) {
              <span class="sd_cn sd_cn--mat" aria-hidden="true">
                <mat-icon>{{ item.matIcon }}</mat-icon>
              </span>
            } @else {
              <figure class="sd_cn">
                <img src="{{ item.img }}" alt="item image" />
              </figure>
            }
            <div class="sidenav-item">
              <h5 class="lead">
                {{ item.text | translate }}
                @if (item.sideBarId === SideBar2Const.Communication && chatNotificationCount && chatNotificationCount > 0) {
                  <span class="badge">{{ chatNotificationCount }}</span>
                }
                @if (item.sideBarId === SideBar2Const.Notification && notificationCount && notificationCount > 0) {
                  <span class="badge">{{ notificationCount }}</span>
                }
                @if (item.sideBarId === SideBar2Const.HelpSupport && supportNotificationCount && supportNotificationCount > 0) {
                  <span class="badge">{{ supportNotificationCount }}</span>
                }
              </h5>
            </div>
          </mat-list-item>
        </ng-container>
        <mat-accordion *ngIf="item.isSubMenu">
          <mat-expansion-panel class="drop_lst_nv">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-list-item
                  (click)="toggleSidenav()">
                  <figure class="sd_cn" mat-raised-button>
                    <img src="{{ item.img }}" alt="" />
                  </figure>
                  <div class="sidenav-item">
                    <h5 class="lead">{{ item.text | translate }}</h5>
                  </div>
                </mat-list-item>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list-item
              *ngFor="let sub of item.subMenuItems"
              [routerLink]="navPath(sub)"
              routerLinkActive="active"
              (click)="toggleSidenav()"
              (keydown)="toggleSidenav()"
              tabindex="0">
              <figure class="sd_cn">
                <img [src]="sub.img" alt="images" />
              </figure>
              <div class="sidenav-item">
                <h5 class="lead">{{ sub.text | translate }}</h5>
              </div>
            </mat-list-item>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }
</mat-nav-list>
